import PropTypes from "prop-types";
import React, {useEffect, useState} from "react";
import {deleteActiveGenderSort, setActiveGenderSort} from "../../helpers/product";
import { isMobileOnly} from "react-device-detect";
import qs from "query-string";
import {useTranslation} from "react-i18next";

const ShopCushioningType = ({ location, currentQuery, setCurrentQuery, cushioningTypes, getSortParams, isHome, isPhysio, setLoadingProducts }) => {
  const [isSmallScreen, setSmallScreen] = useState(false);
    const { t } = useTranslation()

  const query = qs.parse(location.search, {
      ignoreQueryPrefix: true
  });
  const filterButtons = document.querySelectorAll(
      ".sidebar-widget-tag-cushioning-type button"
  );

    filterButtons.forEach(item => {
        item.classList.remove("active");
    });

    if (query && query.cushioningType) {
        let cushioningTypes = query.cushioningType.split('_');
        cushioningTypes.map(size => {
            var element = document.getElementById("cushioningType_"+size);
            if (element){
                element.classList.add("active")
            }
        })
    }

    useEffect(() => {
        const matchResult = window.matchMedia("(max-width: 992px)");
        if (matchResult.matches) {
            setSmallScreen(true)
        }
    }, [])

    window.addEventListener("resize", function() {
        if (window.matchMedia("(min-width: 992px)").matches) {
            setSmallScreen(false)
        }
    })

    function constructAddQueryPath(query, size) {
        if (query && query.cushioningTypes) {
            return query.cushioningTypes + "_" + size
        }
        return size
    }

  return (
    <div className="sidebar-widget mt-10">
        {
            isMobileOnly || isSmallScreen ?
                <div>
                    <h4 className="pro-sidebar-title">
                        {
                            isPhysio && isHome ? "Quel type d'amorti ? (facultatif)" : 
                            isHome ? "Quel type d'amorti ? (facultatif)" : 
                            isPhysio ? "Type d'amorti :" :  "Type d'amorti :"
                        }
                    </h4>
                    <div className="sidebar-widget-tag-cushioning-type mt-10" style={{display: 'block'}}>
                        {cushioningTypes ? (
                            <ul>
                                {cushioningTypes.map((cushioningType, key) => {
                                    return (
                                        <li key={"cushioningType_"+key}>
                                            <button
                                                className="toto"
                                                id={"cushioningType_"+cushioningType}
                                                onClick={e => {
                                                    setLoadingProducts(true)
                                                    if (e.currentTarget.classList.contains('active')) {
                                                        getSortParams("cushioningType", "");
                                                        setCurrentQuery({ ...currentQuery, cushioningType: ""});
                                                        deleteActiveGenderSort(e);
                                                    } else {
                                                        getSortParams("cushioningType", cushioningType);
                                                        setCurrentQuery({ ...currentQuery, cushioningType: cushioningType});
                                                        setActiveGenderSort(e);
                                                    }
                                                }}
                                            >
                                                {t(cushioningType.toLowerCase())}
                                            </button>
                                        </li>
                                    );
                                })}
                            </ul>
                        ) : (
                            "No tags found"
                        )}
                    </div>
                </div>
                :
                <div>
                    <h4 className="pro-sidebar-title">
                        {
                            isPhysio && isHome ? "Quel type d'amorti ? (facultatif)" : 
                            isHome ? "Quel type d'amorti ? (facultatif)" : 
                            isPhysio ? "Type d'amorti :" :  "Type d'amorti :"
                        }
                    </h4>
                    <div className="sidebar-widget-tag-cushioning-type mt-10">
                        {cushioningTypes ? (
                            <ul>
                                {cushioningTypes.map((cushioningType, key) => {
                                    return (
                                        <li key={"cushioningType_"+key}>
                                            <button
                                                className="toto"
                                                id={"cushioningType_"+cushioningType}
                                                onClick={e => {
                                                    setLoadingProducts(true)
                                                    if (e.currentTarget.classList.contains('active')) {
                                                        getSortParams("cushioningType", "");
                                                        setCurrentQuery({ ...currentQuery, cushioningType: ""});
                                                        deleteActiveGenderSort(e);
                                                    } else {
                                                        getSortParams("cushioningType", cushioningType);
                                                        setCurrentQuery({ ...currentQuery, cushioningType: cushioningType});
                                                        setActiveGenderSort(e);
                                                    }
                                                }}
                                            >
                                                {t(cushioningType.toLowerCase())}
                                            </button>
                                        </li>
                                    );
                                })}
                            </ul>
                        ) : (
                            "No tags found"
                        )}
                    </div>
                </div>
        }
    </div>
  );
};

export function getLabel(cushioningType, t){
    switch (cushioningType){
        case "Women":
            return t('cushioningType')
        case "Men":
            return "Homme"
        case "Unisex":
            return "Non Genré"
        default:
            return
    }
}

export function ConstructRemoveGenderQueryPath(query, sizeToRemove) {
    if (query && query.cushioningTypes) {
        let cushioningTypes = query.cushioningTypes.split('_');
        cushioningTypes = cushioningTypes.filter(size => {
            return size !== sizeToRemove;
        })
        if (cushioningTypes.length > 0) {
            let newSizeQuery = ""
            cushioningTypes.map((size, index) => {
                if (index == 0){
                    newSizeQuery += size
                } else {
                    newSizeQuery +=  "_" + size
                }
            })
            return newSizeQuery
        } else {
            return null
        }

    }
    return null
}

ShopCushioningType.propTypes = {
  getSortParams: PropTypes.func,
  tags: PropTypes.array,
  currentQuery: PropTypes.object,
  setCurrentQuery: PropTypes.func,
    location: PropTypes.string
};

export default ShopCushioningType;
